import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ConBile from '../containers/ConBile';
import fn from '../../Functii';
class Mid2ColDr extends React.Component {

    render() {
        // console.log('ColoanaMidDr', this.props);
        if (this.props.rundaSelectata !== null) {
            return (
                <div className='col-midDr'>
                    <div className="module-header">
                        <div>
                            <span className="data">{fn.timeStartTrim(this.props.rundaSelectata.timeStart)}</span>
                            <span className="loteria">{this.props.rundaSelectata.selectedLot} {this.props.rundaSelectata.gameType}</span>
                        </div>
                    </div>
                    <ConBile />
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        rundaSelectata: state.rundaSelectata
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Mid2ColDr);
